<template lang="">
    <div class="main-footer">
        <div class="footer-inner">
            <hr>
            <div class="ft-copy">
                Designed, developed and hosted by LX-LAB
                <br>
                ©{{y}}. All Rights Reserved. LX-LAB
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Footer',
    components: {},
    setup(props) {
        const y = new Date().getFullYear()
        return {y}
    },
}
</script>

<style>
    .main-footer{
        margin-top: 1em;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #2c2c2c;
        color: rgb(218, 218, 218);
    }
    .footer-inner{
        max-width: 65em;
    }
    .ft-copy{
        font-size: 0.8em;
        text-align: center;
        margin-bottom: 1em;
    }
</style>